import { render, staticRenderFns } from "./city-cascader.vue?vue&type=template&id=3b562cab&scoped=true&"
import script from "./city-cascader.vue?vue&type=script&lang=js&"
export * from "./city-cascader.vue?vue&type=script&lang=js&"
import style0 from "./city-cascader.vue?vue&type=style&index=0&id=3b562cab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b562cab",
  null
  
)

export default component.exports